export default "__VITE_ASSET__BUwXqtAm__"